import React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import PackageCatalogueTable from "../../components/ServicePackaging/PackageCatalogueTable";
import CreatePackageCatalogue from "../../components/ServicePackaging/CreatePackageCatalogue";
import MapPackageServices from "../../components/ServicePackaging/MapPackageServices";
import { getServiceTypesMaster } from "../../utils/localStorage";
import find from "lodash/find";
import ConfirmationModalSmall from "../../components/ServicePackaging/ConfirmationModalSmall";


export default function ServicePackagingContainer(props)
{
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const[activePage,setActivePage]=useState("");    

    /*Service Catalogue Table states*/
    const [packageCatalogues, setPackageCatalogues] = useState([]);
    const [packageCataloguesForDuplicate, setPackageCataloguesForDuplicate] = useState([]);
    /*Service Catalogue Table states End*/

    /* Package Filter States */
    const [selectedPackageTypeForFilter,setselectedPackageTypeForFilter] = useState(null);
    const [selectedPackageStatusForFilter,setselectedPackageStatusForFilter] = useState(null);
    const [selectedPackageDeliveryOptionForFilter,setSelectedPackageDeliveryOptionForFilter] = useState(null);
    const [selectedPackageActiveStatusOptionForFilter,setSelectedPackageActiveStatusOptionForFilter] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedStartDateTo, setselectedStartDateTo] = useState("");
	const [selectedStartDateFrom, setselectedStartDateFrom] = useState("");
    /* Package Filter States End */

    /*Create Package Catalogue states */
    const toggleConfirmationModal = () => {
		setShowConfirmationModal(!showConfirmationModal);
	};

    const toggleUnsavedConfirmationModal = () => {
		setShowUnsavedConfirmationModal(!showUnsavedConfirmationModal);
	};
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showUnsavedConfirmationModal, setShowUnsavedConfirmationModal] = useState(false);
    const [packageCatalogueData,setpackageCatalogueData] = useState({});
    const [isEditPackageCatalogue,setIsEditPackageCatalogue] = useState(false);
    const [
		PackageTypesOptions,
		setPackageTypesOptions,
	] = useState([
		{
			value: "Paid",
			label: "Paid",
		},
		{
			value: "Free",
			label: "Free",
		},
        {
            value: "Partner Paid",
            label: "Partner Paid",
        },
        {
            value: "Dynamic",
            label: "Dynamic",
        },
	]);
	const [
		selectedPackageType,
		setselectedPackageType,
	] = useState({
		value: "Paid",
		label: "Paid",
    });
    const [
		PackageStatusOptions,
		setPackageStatusOptions,
	] = useState([
		{
			value: "Draft",
			label: "Draft",
		},
		{
			value: "Published",
			label: "Published",
        },
        {
			value: "Unpublished",
			label: "Unpublished",
		},
	]);
	const [
		selectedPackageStatus,
		setselectedPackageStatus,
	] = useState({
		value: "Draft",
        label: "Draft",
    });
    const [
		packageDeliveryOptions,
		setPackageDeliveryOptions,
	] = useState([
		{
			value: "Delivery on Expiry Date",
			label: "Delivery on Expiry Date",
		},
		{
			value: "Delivery by CSV Import",
			label: "Delivery by CSV Import",
        },
	]);
	const [
		selectedPackageDeliveryOption,
		setSelectedPackageDeliveryOption,
	] = useState({
		value: "Delivery on Expiry Date",
        label: "Delivery on Expiry Date",
    });

    const [
		sTypeOptions,
		setsTypeOptions,
	] = useState([
		{
			value: "Package",
			label: "Package",
		},
		{
			value: "Offering",
			label: "Offering",
        },
        {
			value: "Package And Offering",
			label: "Package And Offering",
        },
	]);
	const [
		selectedsTypeOption,
		setSelectedsTypeOption,
	] = useState({
		value: "Package",
        label: "Package",
    });

    const [
		OfferDeliveryTypeOptions,
		setOfferDeliveryTypeOptions,
	] = useState([
		{
			value: "On Start Date of Offering + No of Days",
			label: "On Start Date of Offering + No of Days",
		},
		{
			value: "On End Date of Offering + No of Days",
			label: "On End Date of Offering + No of Days",
        },
        {
			value: "Manually Delivery By The Facilitator",
			label: "Manually Delivery By The Facilitator",
        },
        {
			value: "As Per Package Delivery Rule",
			label: "As Per Package Delivery Rule",
        },
        {
			value: "Self-Served With Offering Tagged",
			label: "Self-Served With Offering Tagged",
        },
        {
			value: "NA",
			label: "NA",
        },

	]);
	const [
		selectedOfferDeliveryTypeOption,
		setSelectedOfferDeliveryTypeOption,
	] = useState({
		value: "On Start Date of Offering + No of Days",
        label: "On Start Date of Offering + No of Days",
    });

    // const [
	// 	ResourceTypeOptions,
	// 	setResourceTypeOptions,
	// ] = useState([        
    //     {
	// 		value: "Service",
	// 		label: "Service",
    //     },
	// 	{
	// 		value: "Checklist",
	// 		label: "Checklist",
    //     },
    //     {
	// 		value: "Tool",
	// 		label: "Tool",
    //     },
    //     {
	// 		value: "Template",
	// 		label: "Template",
    //     },
    //     {
	// 		value: "Event",
	// 		label: "Event",
	// 	}, 
    //     {
	// 		value: "Package",
	// 		label: "Package",
    //     },       
    //     {
	// 		value: "Program",
	// 		label: "Program",
    //     },
    //     {
	// 		value: "Inspire Program",
	// 		label: "Inspire Program",
    //     },
    //     {
	// 		value: "YUSubscription",
	// 		label: "YUSubscription",
    //     },
    //     {
	// 		value: "YUSubscriptionEN",
	// 		label: "YUSubscriptionEN",
    //     },
    //     {
	// 		value: "YUSubscriptionHI",
	// 		label: "YUSubscriptionHI",
    //     },
	// ]);

    //  const [
	// 	ResourceTypeOptions,
	// 	setResourceTypeOptions,
	// ] = useState([{
    //     label: "Service",
    //     value: "Service"
    //   }, {
    //     label: "Package",
    //     value: "Package"
    //   }, {
    //     label: "Event",
    //     value: "Event"
    //   }, {
    //     label: "Checklist",
    //     value: "Checklist"
    //   }, {
    //     label: "Feedback",
    //     value: "Feedback"
    //   }, {
    //     label: "Magazine",
    //     value: "Magazine"
    //   }, {
    //     label: "EJM Map",
    //     value: "EJM Map"
    //   }, {
    //     label: "deAsra Marketing Event",
    //     value: "deAsra Marketing Event"
    //   }, {
    //     label: "Partner Marketing Event",
    //     value: "Partner Marketing Event"
    //   }, {
    //     label: "Website",
    //     value: "Website"
    //   }, {
    //     label: "Inspire Program",
    //     value: "Inspire Program"
    //   }, {
    //     label: "YUSubscription",
    //     value: "YUSubscription"
    //   }, {
    //     label: "YUSubscriptionEN",
    //     value: "YUSubscriptionEN"
    //   }, {
    //     label: "YUSubscriptionHI",
    //     value: "YUSubscriptionHI"
    //   }, {
    //     label: "Template",
    //     value: "Template"
    //   }, {
    //     label: "Tool",
    //     value: "Tool"
    //   }, {
    //     label: "Program",
    //     value: "Program"
    //   }])

     const [
		ResourceTypeOptions,
		setResourceTypeOptions,
	] = useState()
    
	const [
		selectedResourceTypeOption,
		setSelectedResourceTypeOption,
	] = useState({
        value: "Service",
        label: "Service",
    });

    const [
		packageActiveStatusOptions,
		setPackageActiveStatusOptions,
	] = useState([
		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
        },
	]);
	const [
		selectedPackageActiveStatusOption,
		setSelectedPackageActiveStatusOption,
	] = useState({
		value: true,
        label: "Yes",
    });
    
    /*Create Package Catalogue states End*/  
    
    /*Package service mapping states */
    const [knowledgeResourceList,setKnowledgeResourceList]=useState([]);
    const [personalizedResourceList,setPersonalizedResourceList]=useState([]);
    const [EventResourceList,setEventResourceList]=useState([]);
    const [ResourceNameListOptions,setResourceNameListOptions]=useState([]);
    const [selectedResourceNameListOption,setSelectedResourceNameListOption]=useState(null);
    const [selectedPackageCatalogue,setselectedPackageCatalogue]=useState({});
    const [serviceCatalogueList,setserviceCatalogueList]=useState([]);
    const [serviceCatalogueListOptions,setserviceCatalogueListOptions]=useState([]);
    const [selectedServiceCatalogue,setselectedServiceCatalogue]=useState({});
    const [selectedServiceCatalogueOption,setselectedServiceCatalogueOption]=useState(null);
    const [externalServicePartnerList,setExternalServicePartnerList] = useState([]);
    const [selectedExternalServicePartner,setselectedExternalServicePartner] = useState(null);
    const [packageServiceMappingData,setPackageServiceMappingData] = useState({});
    const [packageMappedServiceList,setPackageMappedServices] = useState([]);
    const [viewIsForEditing,setviewIsForEditing] = useState(false);
    const [selectedPackageMappedService,setSelectedPackageMappedService]=useState({});
    const [selectedResourceForEditing,setSelectedResourceForEditing] = useState({});
    const [selectedResourceForDelete,setSelectedResourceForDelete] = useState({});
    const [isMappingDataChanged,setisMappingDataChanged] = useState(false);
    const [
		platformChargesOptions,
		setPlatformChargesOptions,
	] = useState([
		{
			value: "Fixed",
			label: "Fixed",
		},
		{
			value: "Percentage",
			label: "Percentage",
        },
	]);
	const [
		selectedPlatformChargesOption,
		setSelectedPlatformChargesOption,
	] = useState({
		value: "Fixed",
        label: "Fixed",
    });
    const [
		GSTPercentageOptions,
		setGSTPercentageOptions,
	] = useState([
		{
			value: "2",
			label: "2%",
		},
		{
			value: "5",
			label: "5%",
        },
        {
			value: "12",
			label: "12%",
        },
        {
			value: "18",
			label: "18%",
        },
        {
			value: "25",
			label: "25%",
        },
        {
			value: "28",
			label: "28%",
        },
	]);
	const [
		selectedGSTPercentageOption,
		setSelectedGSTPercentageOption,
	] = useState({
		value: "18",
        label: "18%",
	});
    /*Package service mapping states End */

    useEffect(() => 
    {
        checkUser();
        
    }, []);

    const checkUser=async()=>
    {
        const user = getUser();
		if (!user) {
			this.props.history.push("/login");
			return;
		}
        const roleResponse = await api.getUserRoles();
        const { data: rolesData } = roleResponse;
        let PackageManagerRoleKey = "";
        Object.entries(rolesData).forEach(([key, value]) => {
        if (value === "PACKAGE_MANAGER") {
            PackageManagerRoleKey = parseInt(key);
        }
        });
        const hasPackageManagerRole = user.role.includes(PackageManagerRoleKey);
		if (!hasPackageManagerRole) 
		{
			setActivePage("No_Access");
		} 
        else
        {
            setActivePage("package_catalogue_list");
            getAllPackageCatalogues();
        }
    }
    
    const getAllPackageCatalogues = async () =>
    {
        try 
        {	
            let paylod={};

            if(selectedPackageTypeForFilter)
            {
                paylod.sPackageOfferPaymentType=selectedPackageTypeForFilter.value;
            }

            if(selectedPackageStatusForFilter)
            {
                paylod.sPackageOfferStatus=selectedPackageStatusForFilter.value;
            }

            if(selectedPackageActiveStatusOptionForFilter)
            {
                paylod.bIsActive=selectedPackageActiveStatusOptionForFilter.value;
            }

            if(selectedPackageDeliveryOptionForFilter)
            {
                paylod.sPackageOfferDelivery=selectedPackageDeliveryOptionForFilter.value;
            }

            if(searchTerm)
            {
                paylod.sPackageOfferTitle=searchTerm;
            }

            if(selectedStartDateFrom)
            {
                paylod.dtStartDate = selectedStartDateFrom;
            }

            if(selectedStartDateTo)
            {
                paylod.dtEndDate = adjustedToDate(selectedStartDateTo);
            }
    
			setIsLoading(true);
			const { data } = await api.getAllPackageCatalogues(paylod);
			setIsLoading(false);
			setPackageCatalogues(data);
        } 
        catch (error) 
        {
			console.error(error);
		}
    };

    const getAllPackageCataloguesForDuplicateCheck = async () =>
    {
        try 
        {	
			setIsLoading(true);
			const { data } = await api.getAllPackageCatalogues({});
			setIsLoading(false);
			setPackageCataloguesForDuplicate(data);
        } 
        catch (error) 
        {
			console.error(error);
		}
    };

    const onPackageServicesClicked = (e) => 
    {
        setselectedPackageCatalogue(e);
        showPackageServiceMappingPage(e);
    };

    const onDeactivatePackagClicked = (e) => 
    {
        setselectedPackageCatalogue(e);
        setShowConfirmationModal(true);
    };

    const onEditPackagClicked = (e) => 
    {
        setselectedPackageCatalogue(e);
        getPackageMappedServiceList(e);
        setIsEditPackageCatalogue(true);
        setpackageCatalogueData({
            id:e["id"].toString(),
            sPackageOfferTitle: e["sPackageOfferTitle"].toString(),
            sPackageOfferDesc: e["sPackageOfferDesc"].toString(),
            dtStartDate: new Date(e["dtStartDate"]),
            dtEndDate: new Date(e["dtEndDate"]),
            sInclusions: e["sInclusions"].toString(),
        });
        setselectedPackageType({
            value: e["sPackageOfferPaymentType"].toString(),
            label: e["sPackageOfferPaymentType"].toString()
        });
        setselectedPackageStatus({
            value: e["sPackageOfferStatus"].toString(),
            label: e["sPackageOfferStatus"].toString()
        });
        setSelectedPackageDeliveryOption({
            value: e["sPackageOfferDelivery"].toString(),
            label: e["sPackageOfferDelivery"].toString()
        });
        if(e["sType"])
        {
            setSelectedsTypeOption({
                value: e["sType"].toString(),
                label: e["sType"].toString()
            });
        }
        else
        {
            setSelectedsTypeOption({
                value: "Package",
                label: "Package",
                });
        }
        
        setActivePage("create_package_catalogue");
        getAllPackageCataloguesForDuplicateCheck();
    };

    /*Create Package CallBacks */

    const onCreatePackageClick = () => 
    {
        setIsEditPackageCatalogue(false);
        resetCreateCatalogueForm();        
		setActivePage("create_package_catalogue");
        getAllPackageCataloguesForDuplicateCheck();
    };

    const onCancelCreatePackageCatalogue = () => 
    {
        setIsEditPackageCatalogue(false);
        resetCreateCatalogueForm();
		setActivePage("package_catalogue_list");
    };

    const resetCreateCatalogueForm = () => 
    {
        setpackageCatalogueData({});
        setselectedPackageType({
            value: "Paid",
            label: "Paid",
        });
        setselectedPackageStatus({
            value: "Draft",
            label: "Draft",
        });
        setSelectedPackageDeliveryOption({
            value: "Delivery on Expiry Date",
            label: "Delivery on Expiry Date",
        });
        setSelectedsTypeOption({
		value: "Package",
        label: "Package",
        });
    }
    
    const handleCreatePackageCatalogueDataChange = (name, value) => 
    {
		const updated = { ...packageCatalogueData, [name]: value };
		setpackageCatalogueData(updated);

		const {
			sPackageOfferTitle,
            sPackageOfferDesc,
            sPackageOfferPaymentType,
            dtStartDate,
            dtEndDate,
            bPackageDelivery
        } = updated;
    };
    
    const onSubmitPackageCatalogue = () => 
    {
        try
        {
            const {
                sPackageOfferTitle,
                sPackageOfferDesc,
                dtStartDate,
                dtEndDate,
                sInclusions
            } = packageCatalogueData;
    
            const{value: sPackageOfferPaymentType}=selectedPackageType
            const{value: sPackageOfferStatus}=selectedPackageStatus
            let{value: sPackageOfferDelivery}=selectedPackageDeliveryOption
            const{value: sType}=selectedsTypeOption

            if(!sPackageOfferTitle)
            {
                toast("Package/Offering title is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            let found = false;
            packageCataloguesForDuplicate.map((x) => {
                if (x.sPackageOfferTitle.toLowerCase() == sPackageOfferTitle.toLowerCase()) 
                {
                    found=true;
                }
            });

            if(found)
            {
                toast("Duplicate Package/Offering title is not allowed", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!dtStartDate)
            {
                toast("Start date is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!dtEndDate)
            {
                toast("End date is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!sPackageOfferStatus)
            {
                toast("Package/Offering status is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!sPackageOfferDesc)
            {
                toast("Description is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            if(!sInclusions)
            {
                toast("Inclusions is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            if(!sType)
            {
                toast("Type is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            if(sType!="Package")
            {
                sPackageOfferDelivery="";
            }

            setIsLoading(true);
            api.createPackageCatalogue({
				sPackageOfferTitle,
				sPackageOfferDesc,
                sPackageOfferPaymentType,
                dtStartDate:dtStartDate.toISOString(),
                dtEndDate:dtEndDate.toISOString(),
				sPackageOfferDelivery,
                sPackageOfferStatus,
                sInclusions,
                sType
			})
            .then((response) => 
            {
                setIsLoading(false);
                var d=response;
				if (response.status == 201)
				{
                    setselectedPackageCatalogue(response.data);
                    showPackageServiceMappingPage(response.data);
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else
					{
						toast("Package/Offering created successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				}
				else
				{
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else
					{
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
                }
            }).catch((error) => {
                setIsLoading(false);
                if (error && error.response) 
                {
                     toast(error.response.data, {
                           autoClose: 5000,
                          type: toast.TYPE.ERROR,
                     });
                }
            });
        }
        catch(error)
        {
            /*toast(String(error.response.data.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
            setIsLoading(false);
        }
		
    };

    const onSubmitEditPackageCatalogue = () => 
    {
        try
        {
            const {
                id,
                sPackageOfferTitle,
                sPackageOfferDesc,
                dtStartDate,
                dtEndDate,
                sInclusions
            } = packageCatalogueData;
    
            const{value: sPackageOfferPaymentType}=selectedPackageType
            const{value: sPackageOfferStatus}=selectedPackageStatus
            let{value: sPackageOfferDelivery}=selectedPackageDeliveryOption
            const{value: sType}=selectedsTypeOption

            const{fPackageOfferTotalCost}=selectedPackageCatalogue;
            
            let fPackageOfferTotalCost1=parseFloat(fPackageOfferTotalCost);

    
            if(!sPackageOfferTitle)
            {
                toast("Package/Offering title is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            let found = false;
            packageCataloguesForDuplicate.map((x) => {
                if (x.id!=id&&x.sPackageOfferTitle.toLowerCase() == sPackageOfferTitle.toLowerCase()) 
                {
                    found=true;
                }
            });
            if(found)
            {
                toast("Duplicate package/offering title is not allowed", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            
            if(!dtStartDate)
            {
                toast("Start date is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!dtEndDate)
            {
                toast("End date is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!sPackageOfferStatus)
            {
                toast("Package/Offering status is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
    
            if(!sPackageOfferDesc)
            {
                toast("Offering description is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            if(!sInclusions)
            {
                toast("Inclusions is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            if(!sType)
            {
                toast("Type is required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }

            if(sPackageOfferPaymentType==="Free")
            {
                if(fPackageOfferTotalCost1>0)
                {
                    toast("Free package/offering total amount should be zero", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
            }

            if(sType=="Package")
            {
                if(!sPackageOfferDelivery)
                {
                    toast("Package delivery is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
            }

            if(sPackageOfferStatus==="Published")
            {
                
                if(packageMappedServiceList.length==0)
                {
                    toast("No service/resource is mapped for this package/offering", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if(sPackageOfferPaymentType==="Paid")
                {
                    if(fPackageOfferTotalCost1===0)
                    {
                        toast("Paid package/offering total amount should be greater than zero", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }
            }

            if(sType!="Package")
            {
                sPackageOfferDelivery="";
            }

            let payload={
				sPackageOfferTitle,
				sPackageOfferDesc,
                sPackageOfferPaymentType,
                dtStartDate:dtStartDate.toISOString(),
                dtEndDate:dtEndDate.toISOString(),
				sPackageOfferDelivery,
                sPackageOfferStatus,
                sInclusions,
                sType
			}

            let sjs=payload

            setIsLoading(true);
            api.updatePackageCatalogue(id,
            {
				sPackageOfferTitle,
				sPackageOfferDesc,
                sPackageOfferPaymentType,
                dtStartDate:dtStartDate.toISOString(),
                dtEndDate:dtEndDate.toISOString(),
				sPackageOfferDelivery,
                sPackageOfferStatus,
                sInclusions,
                sType
			})
            .then((response) => 
            {
                setIsLoading(false);
                var d=response;
				if (response.status == 202)
				{
                    //setselectedPackageCatalogue(response.data);
                    //showPackageServiceMappingPage(response.data);
                    onCancelCreatePackageCatalogue();
                    getAllPackageCatalogues();
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else
					{
                        if(sPackageOfferStatus==="Published")
                        {
                            toast("Package/Offering published successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        else
                        {
                            toast("Package/Offering updated successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
					}
				}
				else
				{
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else
					{
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
                }
            }).catch((error) => {
                setIsLoading(false);
                if (error && error.response) 
                {
                     toast(error.response.data, {
                           autoClose: 5000,
                          type: toast.TYPE.ERROR,
                     });
                }
            });
        }
        catch(error)
        {
            /*toast(String(error.response.data.message), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
            setIsLoading(false);
        }
		
    };

    const onSubmitDeactivatePackageCatalogue = () => 
    {
        try
        {
            const {
                id,
            } = selectedPackageCatalogue;
            setIsLoading(true);
           api.updatePackageCatalogue(id,
            {
				bIsActive:false
			})
            .then((response) => 
            {
                setIsLoading(false);
                var d=response;
				if (response.status == 202)
				{
                    setShowConfirmationModal(false)
                    setselectedPackageCatalogue({});
                    getAllPackageCatalogues();
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else
					{
                        toast("Package/Offering deactivated successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
					}
				}
				else
				{
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else
					{
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
                }
            })
        }
        catch(error)
        {
            /*toast(String(error.response.data), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
            setIsLoading(false);
            setShowConfirmationModal(false);
        }
		
    };

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
    };
    
    /*Create Package CallBacks */

    /*Package Service Mapping Callbacks*/

    const showPackageServiceMappingPage = (e) => 
    {
        console.log("eeeeee",e)
        setPackageMappedServices([]);
        resetPackageServiceMappingForm();  
        getServiceCatalogues(e);
        getPackageMappedServiceList(e);
        getAllPackageCataloguesForDuplicateCheck();
        if(e.sPackageOfferPaymentType==="Free")
        {
            const updated = { ...packageServiceMappingData, 
                fPackageOfferAmount: "0",
                fPackageOfferGST:"0",
                fdeAsraPlatformCharges:"0"
             };
             setPackageServiceMappingData(updated);
        }
        setSelectedResourceTypeOption({
			value: "Service",
			label: "Service",
        });
        setActivePage("map_package_services");		
    };

    useEffect(() => 
    {   
        if(selectedPackageCatalogue.sPackageOfferPaymentType==="Free")
        {
            const updated = {
                fPackageOfferAmount: "0",
                fPackageOfferGST:"0",
                fdeAsraPlatformCharges:"0"
             };
             setPackageServiceMappingData(updated);
        }

	}, [selectedPackageCatalogue]);

    const getPackageMappedServiceList=(e)=>
    {
        const{id: refPackageOffer}=e;
        const{sType}=e;
        let payload={refPackageOffer:refPackageOffer};
        let temp = api.getPackageMappedServices(payload)
        .then((d) => 
        {
            let mappedServices = d.data.map((f) => 
            {
                if(sType===''||sType==="Package")
                {
                    return {
                        id: f["id"],
                        refPackageOffer: f["refPackageOffer"],
                        refCatalogue:f["refCatalogue"],
                        refExternalServicePartner: f["refExternalServicePartner"],
                        fPackageOfferAmount: f["fPackageOfferAmount"].toString(),
                        fdeAsraPlatformCharges: f["fdeAsraPlatformCharges"].toString(),
                        fPackageOfferGST: f["fPackageOfferGST"].toString(),
                        sResourceID: f["sResourceID"]?f["sResourceID"].toString():null,
                        sResourceType: f["sResourceType"]?f["sResourceType"].toString():null,
                        sResourceName: f["sResourceName"]?f["sResourceName"].toString():null,
                        nNumberOfDays: f["nNumberOfDays"]?f["nNumberOfDays"].toString():null,
                        sOfferDeliveryType: f["sOfferDeliveryType"]?f["sOfferDeliveryType"].toString():null,
                    };
                }
                else
                {
                    return {
                        id: f["id"],
                        refPackageOffer: f["refPackageOffer"],
                        refCatalogue:f["refCatalogue"],
                        refExternalServicePartner: f["refExternalServicePartner"],
                        fPackageOfferAmount: f["fPackageOfferAmount"].toString(),
                        fdeAsraPlatformCharges: f["fdeAsraPlatformCharges"].toString(),
                        fPackageOfferGST: f["fPackageOfferGST"].toString(),
                        sResourceID: f["sResourceID"]?f["sResourceID"].toString():null,
                        sResourceType: f["sResourceType"].toString(),
                        sResourceName: f["sResourceName"].toString(),
                        nNumberOfDays: f["nNumberOfDays"]===null?null:f["nNumberOfDays"].toString(),
                        sOfferDeliveryType: f["sOfferDeliveryType"]?f["sOfferDeliveryType"].toString():null,
                    };
                }
                
            });
            setPackageMappedServices(mappedServices);            
        });
    }

    const getServiceCatalogues=(e)=>
    {
        try
        {
            const{sType}=e;
            let temp = api.getAllServiceCatalogues()
            .then((d) => 
            {
                let temp = d.data.filter((e) =>e.sDeliveryMode==="Offline"||e.sCatalogueId==="ESTORE");
                
                if(sType===''||sType==="Package")
                {
                    let serviceCatalogues = temp.map((f) => 
                    {
                        return {
                            value: f["sCatalogueId"],
                            label: getServiceName(f["sServiceCode"]),
                        };
                    });
                    setserviceCatalogueList(d.data);
                    setserviceCatalogueListOptions(serviceCatalogues);
                }
                else
                {
                    let serviceCatalogues = temp.map((f) => 
                    {
                        return {
                            value: f["sServiceCode"],
                            label: getServiceName(f["sServiceCode"]),
                        };
                    });
                    setserviceCatalogueList(d.data);
                    setserviceCatalogueListOptions(serviceCatalogues);
                }
            });

            let temp2 = api.getDisableFalseServiceRequestsNames({bDisableService:false,all_resources:true})
            .then((d) => 
            {
                setKnowledgeResourceList(d.data.knowledge_resource);
                setPersonalizedResourceList(d.data.personalized_resource);
                const resourceSubtypeValues = [
                    ...d.data.knowledge_resource.map(resource => resource.sResourceSubType),
                    ...d.data.personalized_resource.map(resource => resource.sResourceSubType)
                  ];
              
                  // Get unique resource subtypes
                  const uniqueResourceSubtypes = [...new Set(resourceSubtypeValues)];
              
                  // Add the additional resource subtypes
                  const additionalResourceSubtypes = ["Service", "Package", "Event"];
              
                  // Combine unique and additional resource subtypes
                  const allResourceSubtypes = [...additionalResourceSubtypes, ...uniqueResourceSubtypes];
              
                  const resourceSubtypes = allResourceSubtypes.map(value => ({
                    value,
                    label: value
                  }));
                  setResourceTypeOptions(resourceSubtypes);
                if(d.data.events)
                {
                    setEventResourceList(d.data.events);
                }
                else
                {
                    setEventResourceList([]);
                }                
            });
        }
        catch(error)
        {
            /*toast(String(error.response.data), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
        }
    }

    const getServiceName = (code) => 
    {
		if (!code) return;
		const found = find(getServiceTypesMaster(), { sServiceCode: code });
		if (found) {
			return found.sServiceName;
		}
		return "";
    };
    
    const getServiceCode = (id) => {
		if (!id) return;
		const found = find(serviceCatalogueList, { sCatalogueId: id });
		if (found) {
            setselectedServiceCatalogue(found);
			return found.sServiceCode;
		}
		return "";
	};

    const getServiceCatalogueID = (code) => {
		if (!code) return;
		const found = find(serviceCatalogueList, { sServiceCode: code });
		if (found) {
			return found.sCatalogueId;
		}
		return "";
	};

    const setServiceCatalogue = (code) => {
		if (!code) return;
		const found = find(serviceCatalogueList, { sServiceCode: code });
		if (found) {
			setselectedServiceCatalogue(found);
		}
	};

    useEffect(() => 
    {
        const{sType}=selectedPackageCatalogue;
        if(!viewIsForEditing)
        {
            setSelectedResourceNameListOption(null);
        }        
        setResourceNameListOptions([]);
        let ResourceList=[];
        if(sType===''||sType==="Package")
        {
            ResourceList=serviceCatalogueListOptions;
        }
        else
        {
            if(selectedResourceTypeOption)
            {
                if(selectedResourceTypeOption.value==="Checklist")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Checklist")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Inspire Program")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Inspire Program")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="YUSubscription")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="YUSubscription")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Udyojak Katta")
                    {
                        knowledgeResourceList.map((f) => 
                        {
                            if(f["sResourceSubType"]==="Udyojak Katta")
                            {
                                ResourceList.push({
                                    value: f["sResourceID"],
                                    label: f["sResourceName"],
                                })
                            }
                        });
                    }
                else if(selectedResourceTypeOption.value==="YUSubscriptionEN")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="YUSubscriptionEN")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="YUSubscriptionHI")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="YUSubscriptionHI")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Feedback")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Feedback")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Magazine")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Magazine")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="EJM Map")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="EJM Map")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="deAsra Marketing Event")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="deAsra Marketing Event")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Partner Marketing Event")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Partner Marketing Event")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Website")
                {
                    knowledgeResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Website")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Template")
                {
                    personalizedResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Template")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Tool")
                {
                    personalizedResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Tool")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Program")
                {
                    personalizedResourceList.map((f) => 
                    {
                        if(f["sResourceSubType"]==="Program")
                        {
                            ResourceList.push({
                                value: f["sResourceID"],
                                label: f["sResourceName"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Package")
                {
                    packageCataloguesForDuplicate.map((f) => 
                    {
                        if(f["bIsActive"]&&f["sPackageOfferStatus"]==="Published"&&(f["sType"]===""||f["sType"]==="Package"))
                        {
                            ResourceList.push({
                                value: f["id"],
                                label: f["sPackageOfferTitle"],
                            })
                        }
                    });
                }
                else if(selectedResourceTypeOption.value==="Event")
                {
                    EventResourceList.map((f) => 
                    {
                        ResourceList.push({
                            value: f["sResourceID"],
                            label: f["sResourceName"],
                        })
                    });
                }
                else
                {
                    ResourceList=serviceCatalogueListOptions;
                }
            }
        }
        
        setResourceNameListOptions(ResourceList);
       
	}, [selectedResourceTypeOption,serviceCatalogueListOptions]);

    useEffect(() => 
    {
        const{sType}=selectedPackageCatalogue;
        setselectedServiceCatalogue(null);
        if(sType===''||sType==="Package")
        {
            if(!viewIsForEditing)
            {
                setselectedExternalServicePartner(null);
            }        
            setExternalServicePartnerList([]);
            if(selectedResourceNameListOption)
            {
                let sServiceCode=getServiceCode(selectedResourceNameListOption.value);                
                if(sServiceCode)
                {
                    let payload={sServiceCode:sServiceCode};
                    api.getExternalServicePartners(payload)
                    .then((d) => 
                    {
                        let externalServicePartners = d.data.map((f) => 
                        {
                            return {
                                value: f["sName"],
                                label: f["sName"] + (f["sServicePartnerOrg"]?" ("+f["sServicePartnerOrg"]+")":""),
                            };
                        });
                        setExternalServicePartnerList(externalServicePartners);
                    });
                }
            }
        }
        else
        {
            if(selectedResourceTypeOption&&selectedResourceTypeOption.value==="Service")
            {
                if(!viewIsForEditing)
                {
                    setselectedExternalServicePartner(null);
                }        
                setExternalServicePartnerList([]);
                if(selectedResourceNameListOption)
                {
                    let sServiceCode=selectedResourceNameListOption.value;
                    
                    if(sServiceCode)
                    {
                        setServiceCatalogue(sServiceCode);
                        let payload={sServiceCode:sServiceCode};
                        api.getExternalServicePartners(payload)
                        .then((d) => 
                        {
                            let externalServicePartners = d.data.map((f) => 
                            {
                                return {
                                    value: f["sName"],
                                    label: f["sName"]+(f["sServicePartnerOrg"]?" ("+f["sServicePartnerOrg"]+")":""),
                                };
                            });
                            setExternalServicePartnerList(externalServicePartners);
                        });
                    }
                }
            }
        }
        
	}, [selectedResourceNameListOption]);

    const handlePackageServiceMappingDataChange = (name, value) => 
    {
        const floatRegExp = new RegExp('^([0-9]+([.][0-9]*)?|[.][0-9]+)$');
        if (value!=''&&floatRegExp.test(value) === false)  
        {
            return;
        }

        //const updated = { ...packageServiceMappingData, [name]: value};
		//setPackageServiceMappingData(updated);

		const {
			fPackageOfferAmount,
            fdeAsraPlatformCharges,
            fPackageOfferGST,
            fPlatformChargePercentage,
            nNumberOfDays
        } = packageServiceMappingData;

        //for AUTO GST Calculation
        let fPackageOfferAmount1=0;
        let fdeAsraPlatformCharges1=0;
        let fPackageOfferGST1=0;
        let fPlatformChargePercentage1=0;
        let nNumberOfDays1=0;
        

        if(nNumberOfDays&&nNumberOfDays!='')
        {
            nNumberOfDays1=parseFloat(nNumberOfDays);
        }

        if(fPackageOfferAmount&&fPackageOfferAmount!='')
        {
            fPackageOfferAmount1=parseFloat(fPackageOfferAmount);
        }
        if(name==='fPackageOfferAmount')
        {
            if(value!='')
            {
                fPackageOfferAmount1=parseFloat(value);
            }
            else
            {
                fPackageOfferAmount1=0;
            }
        }

        if(fdeAsraPlatformCharges&&fdeAsraPlatformCharges!='')
        {
            fdeAsraPlatformCharges1=parseFloat(fdeAsraPlatformCharges);
        }
        if(name==='fdeAsraPlatformCharges')
        {
            if(value!='')
            {
                fdeAsraPlatformCharges1=parseFloat(value);
            }
            else
            {
                fdeAsraPlatformCharges1=0;
            }
            
        }
        if(selectedPlatformChargesOption.value==="Percentage")
        {
            if(fPlatformChargePercentage&&fPlatformChargePercentage!='')
            {
                fPlatformChargePercentage1=parseFloat(fPlatformChargePercentage);
            }

            if(name==='fPlatformChargePercentage')
            {
                if(value!='')
                {
                    fPlatformChargePercentage1=parseFloat(value);
                }
                else
                {
                    fPlatformChargePercentage1=0;
                }
            }

            fdeAsraPlatformCharges1=((fPackageOfferAmount1)*fPlatformChargePercentage1)/100;
        }

        if(name==='nNumberOfDays')
        {
            if(value!='')
            {
                nNumberOfDays1=parseFloat(value);
            }
            else
            {
                nNumberOfDays1=0;
            }
        }

        if(selectedPackageCatalogue.sPackageOfferPaymentType=="Free")
        {
            fPackageOfferAmount1=0;
            fdeAsraPlatformCharges1=0
        }

        let gstper=parseFloat(selectedGSTPercentageOption.value);
        fPackageOfferGST1=((fdeAsraPlatformCharges1)*gstper)/100;

        const updated = { ...packageServiceMappingData,
            fPackageOfferAmount:fPackageOfferAmount1.toString(),
            fPackageOfferGST:fPackageOfferGST1.toString(),
            fdeAsraPlatformCharges:fdeAsraPlatformCharges1.toString(),
            fPlatformChargePercentage:fPlatformChargePercentage1.toString(),
            nNumberOfDays:nNumberOfDays1.toString(),
         };
         setPackageServiceMappingData(updated);
    };

    useEffect(() => 
    {   
        
        const {
			fPackageOfferAmount,
            fdeAsraPlatformCharges,
            fPackageOfferGST,
            fPlatformChargePercentage
        } = packageServiceMappingData;

        //for AUTO GST Calculation
        let fPackageOfferAmount1=0;
        let fdeAsraPlatformCharges1=0;
        let fPackageOfferGST1=0;
        let fPlatformChargePercentage1=0;
        

        if(fPackageOfferAmount&&fPackageOfferAmount!='')
        {
            fPackageOfferAmount1=parseFloat(fPackageOfferAmount);
        }

        if(fdeAsraPlatformCharges&&fdeAsraPlatformCharges!='')
        {
            fdeAsraPlatformCharges1=parseFloat(fdeAsraPlatformCharges);
        }

        if(selectedPlatformChargesOption.value==="Percentage")
        {
            if(fPlatformChargePercentage&&fPlatformChargePercentage!='')
            {
                fPlatformChargePercentage1=parseFloat(fPlatformChargePercentage);
            }
            fdeAsraPlatformCharges1=((fPackageOfferAmount1)*fPlatformChargePercentage1)/100;
        }

        let gstper=parseFloat(selectedGSTPercentageOption.value);
        fPackageOfferGST1=((fdeAsraPlatformCharges1)*gstper)/100;
        

        const updated = { ...packageServiceMappingData,
            fPackageOfferAmount:fPackageOfferAmount1.toString(),
            fPackageOfferGST:fPackageOfferGST1.toString(),
            fdeAsraPlatformCharges:fdeAsraPlatformCharges1.toString(),
            fPlatformChargePercentage:fPlatformChargePercentage1.toString()
        };
		setPackageServiceMappingData(updated);
       
    }, [selectedGSTPercentageOption,selectedPlatformChargesOption]);

    useEffect(() => 
    {   
        
        const {
			nNumberOfDays
        } = packageServiceMappingData;

        let nNumberOfDays1=0;  
        if(nNumberOfDays)    
        {
            nNumberOfDays1=nNumberOfDays; 
        } 
        const updated = { ...packageServiceMappingData,
            nNumberOfDays:nNumberOfDays1.toString(),
        };
		setPackageServiceMappingData(updated);
       
    }, [selectedOfferDeliveryTypeOption]);
    
    const onAddPackageService = () => 
    {
        
        if(selectedPackageCatalogue)
        {
            const 
            {
                fPackageOfferAmount,
                fdeAsraPlatformCharges,
                fPackageOfferGST,
                nNumberOfDays
            } = packageServiceMappingData;
    
            let refCatalogue=null;
            let refExternalServicePartner=null
            let sResourceType=null;
            let sResourceID=null;
            let sResourceName=null;
            let sOfferDeliveryType=null;
            let nNumberOfDays1 = null;
            let sSpeakerName = null
            let sSpeakerOrganization = null

            /*if(selectedServiceCatalogueOption)
            {
                const {value: refCat}=selectedServiceCatalogueOption;
                refCatalogue=refCat;
            }*/

            const{id: refPackageOffer}=selectedPackageCatalogue;
            const{sType}=selectedPackageCatalogue;

            if(sType===''||sType==="Package")
            {
                if(selectedResourceNameListOption)
                {
                    const {value: srefCatalogue}=selectedResourceNameListOption;
                    refCatalogue=srefCatalogue;

                    sResourceID= getServiceCode(refCatalogue);

                    const {label: ResourceName}=selectedResourceNameListOption;
                    sResourceName=ResourceName;
                }

                if(selectedExternalServicePartner)
                {
                    const {value: refExternalSerPartner}=selectedExternalServicePartner;
                    refExternalServicePartner=refExternalSerPartner
                }

                if(!refCatalogue)
                {
                    toast("Service catalogue is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner") {
                    if (selectedSpeakerDataOption === "") {
                        toast("Speaker Name is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }
                    
                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner") {
                    if(!refExternalServicePartner)
                {
                    toast("External service partner is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
                }
            

                // if(!refExternalServicePartner)
                // {
                //     toast("External service partner is required", {
                //         autoClose: 5000,
                //         type: toast.TYPE.ERROR,
                //     });
                //     return;
                // }

                //sResourceID=null
                sResourceType="Service";
                //sResourceName=null;
                sOfferDeliveryType=null;
                nNumberOfDays1=null;
            }
            else
            {
                nNumberOfDays1=nNumberOfDays;
                refCatalogue=null;
                if(selectedResourceTypeOption)
                {
                    const {value: ResourceType}=selectedResourceTypeOption;
                    sResourceType=ResourceType;
                }

                if(selectedOfferDeliveryTypeOption)
                {
                    const {value: OfferDeliveryType}=selectedOfferDeliveryTypeOption;
                    sOfferDeliveryType=OfferDeliveryType;
                }

                if(selectedResourceNameListOption)
                {
                    const {value: ResourceID}=selectedResourceNameListOption;
                    sResourceID=ResourceID;

                    const {label: ResourceName}=selectedResourceNameListOption;
                    sResourceName=ResourceName;

                    if(sResourceType&&sResourceType==="Service")
                    {
                        refCatalogue=getServiceCatalogueID(sResourceID);
                    }
                }

                if(selectedExternalServicePartner)
                {
                    const {value: refExternalSerPartner}=selectedExternalServicePartner;
                    refExternalServicePartner=refExternalSerPartner
                }

                if(!sResourceType)
                {
                    toast("Resource type is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
    
                if(!sResourceName)
                {
                    toast("Resource name is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT") {
                    if (selectedSpeakerDataOption === "") {
                        toast("Speaker Name is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT") {
                    if(sResourceType==="Service")
                {
                    if(!refExternalServicePartner)
                    {
                        toast("External service partner is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }
                }
    
                // if(sResourceType==="Service")
                // {
                //     if(!refExternalServicePartner)
                //     {
                //         toast("External service partner is required", {
                //             autoClose: 5000,
                //             type: toast.TYPE.ERROR,
                //         });
                //         return;
                //     }
                // }

                
                
                if(!nNumberOfDays)
                {
                    toast("Number of days is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
                
                if(!sOfferDeliveryType)
                {
                    toast("Offer delivery type is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
                if(sOfferDeliveryType==="On Start Date of Offering + No of Days"||sOfferDeliveryType==="On End Date of Offering + No of Days")
                {
                    nNumberOfDays1=nNumberOfDays;
                }
                else{
                    nNumberOfDays1=null;
                }                
            }

            // if(!fPackageOfferAmount)
            // {
            //     toast("Package amount is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            // if(!fdeAsraPlatformCharges)
            // {
            //     toast("Platform charges is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            // if(!fPackageOfferGST)
            // {
            //     toast("GST amount is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            let fPackageOfferAmount1=parseFloat(fPackageOfferAmount);
            let fdeAsraPlatformCharges1=parseFloat(fdeAsraPlatformCharges);
            let fPackageOfferGST1=parseFloat(fPackageOfferGST);
    
            let zero = Number(0)
             
            if(isNaN(fPackageOfferAmount1) && isNaN(fdeAsraPlatformCharges1)){
                setPackageMappedServices([...packageMappedServiceList, 
                    {
                        refPackageOffer: refPackageOffer,
                        refCatalogue: refCatalogue,
                        refExternalServicePartner: refExternalServicePartner,
                        fPackageOfferAmount: 0,
                        fdeAsraPlatformCharges: 0,
                        fPackageOfferGST: 0,
                        sResourceType:sResourceType,
                        sResourceID:sResourceID,
                        sResourceName:sResourceName,
                        sOfferDeliveryType:sOfferDeliveryType,
                        nNumberOfDays: nNumberOfDays1,
                        sSpeakerName: selectedSpeakerDataOption['value'] || null,
                        sSpeakerOrganization: selectedSpeakerDataOption['val'] || null
                    }]);
            } else {
                setPackageMappedServices([...packageMappedServiceList, 
                    {
                        refPackageOffer: refPackageOffer,
                        refCatalogue: refCatalogue,
                        refExternalServicePartner: refExternalServicePartner,
                        fPackageOfferAmount: fPackageOfferAmount1,
                        fdeAsraPlatformCharges: fdeAsraPlatformCharges1,
                        fPackageOfferGST: fPackageOfferGST1,
                        sResourceType:sResourceType,
                        sResourceID:sResourceID,
                        sResourceName:sResourceName,
                        sOfferDeliveryType:sOfferDeliveryType,
                        nNumberOfDays: nNumberOfDays1,
                        sSpeakerName: selectedSpeakerDataOption['value'] || null,
                        sSpeakerOrganization: selectedSpeakerDataOption['val'] || null
                    }]);
            }
            setisMappingDataChanged(true);
            setSelectedSpeakerDataOption('')

            resetPackageServiceMappingForm();
            if(selectedPackageCatalogue.sPackageOfferPaymentType==="Free")
            {
                const updated = { ...packageServiceMappingData, 
                    fPackageOfferAmount: "0",
                    fPackageOfferGST:"0",
                    fdeAsraPlatformCharges:"0"
                };
                setPackageServiceMappingData(updated);
            }
        }        
    };

    const onCancelPackageServiceMapping = () => 
    {
        if(isMappingDataChanged)
        {
            setShowUnsavedConfirmationModal(true);
        }
        else
        {
            setPackageMappedServices([]);
            resetPackageServiceMappingForm();
            getAllPackageCatalogues();
            setActivePage("package_catalogue_list");
        }
    };

    const onConfirmCancelPackageServiceMapping = () =>
    {
        setShowUnsavedConfirmationModal(false);
        setPackageMappedServices([]);
        resetPackageServiceMappingForm();
        getAllPackageCatalogues();
        setActivePage("package_catalogue_list");
    };

    const resetPackageServiceMappingForm = () => 
    {
        setSelectedResourceForEditing({});
        setSelectedResourceForDelete({});
        setviewIsForEditing(false);        
        setselectedServiceCatalogueOption(null);
        setselectedExternalServicePartner(null);        
        setSelectedPlatformChargesOption({
            value: "Fixed",
            label: "Fixed"
        });
        setSelectedGSTPercentageOption({
            value: "18",
            label: "18%",
        });
        setSelectedResourceTypeOption({
			value: "Service",
			label: "Service",
        });
        setSelectedResourceNameListOption(null);
        setSelectedOfferDeliveryTypeOption({
		value: "On Start Date of Offering + No of Days",
        label: "On Start Date of Offering + No of Days",
        });
        setPackageServiceMappingData({});
        setselectedServiceCatalogue({});        
    }

    const onSubmitPackageServiceMapping = () => 
    {
        try
        {
            if(packageMappedServiceList.length>0)
            {
                let temppackageMappedServiceList= packageMappedServiceList.map((x) => 
                {
                    x.fPackageOfferAmount= parseFloat(x.fPackageOfferAmount);
                    x.fdeAsraPlatformCharges= parseFloat(x.fdeAsraPlatformCharges);
                    x.fPackageOfferGST= parseFloat(x.fPackageOfferGST);
                    x.nNumberOfDays= x.nNumberOfDays?parseFloat(x.nNumberOfDays):x.nNumberOfDays;
                    return x;
                });

                let sds=temppackageMappedServiceList;
                setIsLoading(true);
                api.mapPackageServices(temppackageMappedServiceList)
                .then((response) => 
                {
                    setIsLoading(false);
                    var d=response;
                    if (response.status == 201)
                    {
                        setisMappingDataChanged(false);
                        resetCreateCatalogueForm();
                        resetPackageServiceMappingForm();
                        setPackageMappedServices([]);
                        getAllPackageCatalogues();                        
		                setActivePage("package_catalogue_list");

                        if(response.data.message)
                        {
                            if(response.data.message==="Success.")
                            {
                                toast("Package services mapped successfully.", {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                            }
                            else
                            {
                                toast(response.data.message, {
                                    autoClose: 5000,
                                    type: toast.TYPE.SUCCESS,
                                });
                            }
                        }
                        else
                        {
                            toast("Package services mapped successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                    }
                    else
                    {
                        if(response.data.message)
                        {
                            toast(response.data.message, {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                        else
                        {
                            toast("Internal server error.", {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });
                        }
                    }
                })
            }
            else
            {
                toast("Please add service first.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
        }
        catch(error)
        {
            /*toast(String(error.response.data), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
            setIsLoading(false);
        }
		
    };

    /*Package Service Mapping Callbacks End*/

    /*Edit Mapped service callbacks*/
    const onEditMappedserviceClicked = (e) => 
    {
        setSelectedResourceForEditing(e);
        setviewIsForEditing(true);
        setPackageServiceMappingData({
            fPackageOfferAmount: e["fPackageOfferAmount"].toString(),
            fdeAsraPlatformCharges: e["fdeAsraPlatformCharges"].toString(),
            fPackageOfferGST: e["fPackageOfferGST"].toString(),
            nNumberOfDays:e["nNumberOfDays"]?e["nNumberOfDays"].toString():null,
        });

        const{sType}=selectedPackageCatalogue;
        if(sType===''||sType==="Package")
        {
            setSelectedResourceNameListOption({
                value: e["refCatalogue"],
                label: getServiceName(getServiceCode(e["refCatalogue"])),
            });

            setselectedExternalServicePartner({
                value: e["refExternalServicePartner"],
                label: e["refExternalServicePartner"],
            });
        }
        else
        {
            setSelectedResourceTypeOption({
                value:e["sResourceType"],
                label: e["sResourceType"],
            });

            if(e["sResourceType"]==="Service")
            {
                setSelectedResourceNameListOption({
                    value: e["sResourceID"],
                    label: e["sResourceName"],
                });

                setselectedExternalServicePartner({
                    value: e["refExternalServicePartner"],
                    label: e["refExternalServicePartner"],
                });
            }
            else
            {
                setSelectedResourceNameListOption({
                    value: e["sResourceID"],
                    label: e["sResourceName"],
                });
                setselectedExternalServicePartner(null);
            }
            setSelectedOfferDeliveryTypeOption({
                value: e["sOfferDeliveryType"],
                label: e["sOfferDeliveryType"],
            });
        }

        setSelectedPlatformChargesOption({
            value: "Fixed",
            label: "Fixed"
        });

        let totalPlatformCharges=parseFloat(e["fdeAsraPlatformCharges"]);
        let fPackageOfferGST=parseFloat(e["fPackageOfferGST"]);
        let percenatge=0;
        percenatge=(fPackageOfferGST/totalPlatformCharges)*100;
        if(fPackageOfferGST>0)
        {
            setSelectedGSTPercentageOption({
                value: percenatge.toString(),
                label: percenatge.toString()+"%",
            });
        }
        else
        {
            setSelectedGSTPercentageOption({
                value: "18",
                label:"18%",
            });
        }
    };

    const onDeleteMappedserviceClicked = (e) => 
    {
        setSelectedResourceForDelete(e);
        setSelectedPackageMappedService(e);
        setShowConfirmationModal(true);
    };

    const onUpdatePackageService = () => 
    {
        if(selectedPackageCatalogue)
        {
            const 
            {
                fPackageOfferAmount,
                fdeAsraPlatformCharges,
                fPackageOfferGST,
                nNumberOfDays
            } = packageServiceMappingData;


            let refCatalogue=null;
            let refExternalServicePartner=null
            let sResourceType=null;
            let sResourceID=null;
            let sResourceName=null;
            let sOfferDeliveryType=null;
            let nNumberOfDays1=null;

            const{id: refPackageOffer}=selectedPackageCatalogue;
            const{sType}=selectedPackageCatalogue;

            /*if(selectedServiceCatalogueOption)
            {
                const {value: refCat}=selectedServiceCatalogueOption;
                refCatalogue=refCat;
            }*/

            if(sType===''||sType==="Package")
            {
                if(selectedResourceNameListOption)
                {
                    const {value: srefCatalogue}=selectedResourceNameListOption;
                    refCatalogue=srefCatalogue;

                    sResourceID= getServiceCode(refCatalogue);

                    const {label: ResourceName}=selectedResourceNameListOption;
                    sResourceName=ResourceName;
                }

                if(selectedExternalServicePartner)
                {
                    const {value: refExternalSerPartner}=selectedExternalServicePartner;
                    refExternalServicePartner=refExternalSerPartner
                }

                if(!refCatalogue)
                {
                    toast("Service catalogue is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner") {
                    if (selectedSpeakerDataOption === "") {
                        toast("Speaker Name is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT_SP_paid_service_Offline_Partner") {
                    if(!refExternalServicePartner)
                {
                    toast("External service partner is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
                }

                // if(!refExternalServicePartner)
                // {
                //     toast("External service partner is required", {
                //         autoClose: 5000,
                //         type: toast.TYPE.ERROR,
                //     });
                //     return;
                // }

                //sResourceID=null
                sResourceType="Service";
                //sResourceName=null;
                sOfferDeliveryType=null;
                nNumberOfDays1=null;
            }
            else
            {
                nNumberOfDays1=nNumberOfDays;
                refCatalogue=null;
                if(selectedResourceTypeOption)
                {
                    const {value: ResourceType}=selectedResourceTypeOption;
                    sResourceType=ResourceType;
                }

                if(selectedOfferDeliveryTypeOption)
                {
                    const {value: OfferDeliveryType}=selectedOfferDeliveryTypeOption;
                    sOfferDeliveryType=OfferDeliveryType;
                }

                if(selectedResourceNameListOption)
                {
                    const {value: ResourceID}=selectedResourceNameListOption;
                    sResourceID=ResourceID;

                    const {label: ResourceName}=selectedResourceNameListOption;
                    sResourceName=ResourceName;

                    if(sResourceType&&sResourceType==="Service")
                    {
                        refCatalogue=getServiceCatalogueID(sResourceID);
                    }
                }

                if(selectedExternalServicePartner)
                {
                    const {value: refExternalSerPartner}=selectedExternalServicePartner;
                    refExternalServicePartner=refExternalSerPartner
                }

                if(!sResourceType)
                {
                    toast("Resource type is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
    
                if(!sResourceName)
                {
                    toast("Resource name is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT") {
                    if (selectedSpeakerDataOption === "") {
                        toast("Speaker Name is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }

                if (selectedResourceNameListOption.value === "GRPEXPRTCONSULT") {
                    if(sResourceType==="Service")
                {
                    if(!refExternalServicePartner)
                    {
                        toast("External service partner is required", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                        return;
                    }
                }
                }
    
                // if(sResourceType==="Service")
                // {
                //     if(!refExternalServicePartner)
                //     {
                //         toast("External service partner is required", {
                //             autoClose: 5000,
                //             type: toast.TYPE.ERROR,
                //         });
                //         return;
                //     }
                // } 
                
                if(!nNumberOfDays)
                {
                    toast("Number of days is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }
                
                if(!sOfferDeliveryType)
                {
                    toast("Offer delivery type is required", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                    return;
                }

                if(sOfferDeliveryType==="On Start Date of Offering + No of Days"||sOfferDeliveryType==="On End Date of Offering + No of Days")
                {
                    nNumberOfDays1=nNumberOfDays;
                }
                else{
                    nNumberOfDays1=null;
                }  
            }

            // if(!fPackageOfferAmount)
            // {
            //     toast("Package amount is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            // if(!fdeAsraPlatformCharges)
            // {
            //     toast("Platform charges is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            // if(!fPackageOfferGST)
            // {
            //     toast("GST amount is required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     });
            //     return;
            // }

            let fPackageOfferAmount1=parseFloat(fPackageOfferAmount);
            let fdeAsraPlatformCharges1=parseFloat(fdeAsraPlatformCharges);
            let fPackageOfferGST1=parseFloat(fPackageOfferGST);

            let tempMappedServices = packageMappedServiceList.map((x) => {
                if(sType===''||sType==="Package")
                {
                    /*if (x.refCatalogue == selectedResourceForEditing.refCatalogue
                        &&x.refExternalServicePartner === selectedResourceForEditing.refExternalServicePartner
                        &&x.fPackageAmount == selectedResourceForEditing.fPackageAmount)*/
                    if(x===selectedResourceForEditing) 
                    {
                        x.refPackageOffer= refPackageOffer;
                        x.refCatalogue= refCatalogue;
                        x.refExternalServicePartner=refExternalServicePartner;
                        x.fPackageOfferAmount= fPackageOfferAmount1;
                        x.fdeAsraPlatformCharges= fdeAsraPlatformCharges1;
                        x.fPackageOfferGST= fPackageOfferGST1;
                        x.sResourceID=sResourceID
                        x.sResourceType=sResourceType;
                        x.sResourceName=sResourceName;
                        x.sOfferDeliveryType=sOfferDeliveryType;
                        x.nNumberOfDays = nNumberOfDays1;
                        x.sSpeakerName= selectedSpeakerDataOption['value'];
                        x.sSpeakerOrganization= selectedSpeakerDataOption['val']
                    }
                }
                else
                {
                    if(selectedResourceForEditing.sResourceType==="Service")
                    {
                        /*if (x.sResourceType === selectedResourceForEditing.sResourceType 
                            && x.sResourceName === selectedResourceForEditing.sResourceName
                            &&x.refExternalServicePartner === selectedResourceForEditing.refExternalServicePartner
                            &&x.sOfferDeliveryType===selectedResourceForEditing.sOfferDeliveryType
                            &&x.fPackageAmount == selectedResourceForEditing.fPackageAmount) */
                            if(x===selectedResourceForEditing)
                        {
                            x.refPackageOffer= refPackageOffer;
                            x.refCatalogue= refCatalogue;
                            x.refExternalServicePartner=refExternalServicePartner;
                            x.fPackageOfferAmount= fPackageOfferAmount1;
                            x.fdeAsraPlatformCharges= fdeAsraPlatformCharges1;
                            x.fPackageOfferGST= fPackageOfferGST1;
                            x.sResourceType=sResourceType;
                            x.sResourceID=sResourceID
                            x.sResourceName=sResourceName;
                            x.sOfferDeliveryType=sOfferDeliveryType;
                            x.nNumberOfDays = nNumberOfDays1;
                            x.sSpeakerName= selectedSpeakerDataOption['value'];
                            x.sSpeakerOrganization= selectedSpeakerDataOption['val']
                        }
                    }
                    else
                    {
                        /*if (x.sResourceType === selectedResourceForEditing.sResourceType 
                            && x.sResourceName === selectedResourceForEditing.sResourceName
                            &&x.sOfferDeliveryType===selectedResourceForEditing.sOfferDeliveryType
                            &&x.fPackageAmount == selectedResourceForEditing.fPackageAmount)*/
                        if(x===selectedResourceForEditing)
                        {
                            x.refPackageOffer= refPackageOffer;
                            x.refCatalogue= refCatalogue;
                            x.refExternalServicePartner=refExternalServicePartner;
                            x.fPackageOfferAmount= fPackageOfferAmount1;
                            x.fdeAsraPlatformCharges= fdeAsraPlatformCharges1;
                            x.fPackageOfferGST= fPackageOfferGST1;
                            x.sResourceType=sResourceType;
                            x.sResourceID=sResourceID
                            x.sResourceName=sResourceName;
                            x.sOfferDeliveryType=sOfferDeliveryType;
                            x.nNumberOfDays = nNumberOfDays1;
                            x.sSpeakerName= selectedSpeakerDataOption['value'];
                            x.sSpeakerOrganization= selectedSpeakerDataOption['val']
                            
                        }
                    }
                    
                }
				return x;
			});
    
            setPackageMappedServices(tempMappedServices);
            setisMappingDataChanged(true);
            resetPackageServiceMappingForm();
            if(selectedPackageCatalogue.sPackageOfferPaymentType==="Free")
            {
                const updated = { ...packageServiceMappingData, 
                    fPackageOfferAmount: "0",
                    fPackageOfferGST:"0",
                    fdeAsraPlatformCharges:"0"
                };
                setPackageServiceMappingData(updated);
            }
        }
        
    };

    const onSubmitDeletePackageMappedservice = () => 
    {
        try
        {
            if(selectedPackageMappedService)
            {
                const 
                {
                    id,
                    refCatalogue,
                    sResourceType,
                    sResourceName,
                    refExternalServicePartner,
                    fPackageAmount,
                    sOfferDeliveryType,


                } = selectedPackageMappedService;
                const{sType}=selectedPackageCatalogue;                   

                if(id)
                {
                    setIsLoading(true);
                    api.deletePackageMappedService(id)
                    .then((response) => 
                    {
                        setIsLoading(false);
                        var d=response;
                        if (response.status == 204)
                        {
                            setisMappingDataChanged(true);
                            if(sType===''||sType==="Package")
                            {
                                let tempMappedServices = [];
                                packageMappedServiceList.map((x) => {
                                    if (x.id != id) 
                                    {
                                        tempMappedServices.push(x);
                                    }
                                });
                    
                                setPackageMappedServices(tempMappedServices);
                                resetPackageServiceMappingForm();
                                setShowConfirmationModal(false);  
                            }
                            else
                            {
                                let tempMappedServices = [];
                                packageMappedServiceList.map((x) => {
                                    if (x.id != id) 
                                    {
                                        tempMappedServices.push(x);
                                    }
                                });
            
                                setPackageMappedServices(tempMappedServices);
                                resetPackageServiceMappingForm();
                                setShowConfirmationModal(false); 
                            }

                            toast("Service deleted successfully.", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                        }
                        else
                        {
                            if(response.data.message)
                            {
                                toast(response.data.message, {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                            else if(response.data.detail)
                            {
                                toast(response.data.detail, {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                            else
                            {
                                toast("Internal server error.", {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                        }
                    }).catch((error) => {
                        setIsLoading(false);
                        if (error && error.response) 
                        {
                            if(error.response.data)
                            {
                                if(error.response.data.message)
                                {
                                    toast(error.response.data.message, {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                                else if(error.response.data.detail)
                                {
                                    toast(error.response.data.detail, {
                                        autoClose: 5000,
                                        type: toast.TYPE.ERROR,
                                    });
                                }
                                else
                                {
                                    toast(error.response.data, {
                                        autoClose: 5000,
                                       type: toast.TYPE.ERROR,
                                  });
                                }
                            }
                            else
                            {
                                toast("Internal server error.", {
                                    autoClose: 5000,
                                    type: toast.TYPE.ERROR,
                                });
                            }
                        }
                    });
                }
                else
                {
                    setisMappingDataChanged(true);
                    const{sType}=selectedPackageCatalogue;
                    if(sType===''||sType==="Package")
                    {
                        let tempMappedServices = [];
                        packageMappedServiceList.map((x) => {
                            /*if (x.refCatalogue != refCatalogue&&x.refExternalServicePartner == refExternalServicePartner
                                &&x.fPackageAmount == fPackageAmount)*/
                            if(x===selectedResourceForDelete) 
                            {
                                
                            }
                            else
                            {
                                tempMappedServices.push(x);
                            }
                        });
            
                        setPackageMappedServices(tempMappedServices);
                        resetPackageServiceMappingForm();
                        setShowConfirmationModal(false);
                        toast("Service deleted successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                    }
                    else
                    {
                        let tempMappedServices = [];
                        packageMappedServiceList.map((x) =>
                        {
                            if(sResourceType==="Service")
                            {
                                /*if (x.sResourceType === sResourceType && x.sResourceName === sResourceName
                                    &&x.refExternalServicePartner === refExternalServicePartner
                                    &&x.sOfferDeliveryType===sOfferDeliveryType
                                    &&x.fPackageAmount == fPackageAmount)*/
                                if(x===selectedResourceForDelete) 
                                {
                                    
                                }
                                else
                                {
                                    tempMappedServices.push(x);
                                }
                            }
                            else
                            {
                                /*if (x.sResourceType === sResourceType && x.sResourceName === sResourceName
                                    &&x.sOfferDeliveryType===sOfferDeliveryType&&x.fPackageAmount == fPackageAmount) */
                                if(x===selectedResourceForDelete)
                                {
                                    
                                }
                                else
                                {
                                    tempMappedServices.push(x);
                                }
                            }
                        });
            
                        setPackageMappedServices(tempMappedServices);
                        resetPackageServiceMappingForm();
                        setShowConfirmationModal(false);
                        toast("Service deleted successfully.", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                    }
                    
                }
            }
        }
        catch(error)
        {
            /*toast(String(error.response.data), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });*/
            setIsLoading(false);
        }
    };

    /*Edit Mapped service callbacks end*/

    /*Package filters callbacks */
    const handleSearchClick = async () => {
		getAllPackageCatalogues();		
	};
	const handleClearFilterSearch = () => {
		setSearchTerm("");
        setselectedPackageTypeForFilter(null);
        setselectedPackageStatusForFilter(null);
        setSelectedPackageActiveStatusOptionForFilter(null);
        setSelectedPackageDeliveryOptionForFilter(null)
        setselectedStartDateTo("");
        setselectedStartDateFrom("");
	};
    const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
	};
    /*Package filters callbacks End */

    const [speakerData, setSpeakerData] = useState()
    const [selectedSpeakerDataOption, setSelectedSpeakerDataOption] = useState('')

    

    const handleSpeakerList = () => {
        let payload = {
            // api_key: '82mqEyJnct4kzC8y'
            api_key: "r54B?rHXUE7v%$9t"
        }
        api.getSpeakerList(payload).then(({ data }) => {
            setSpeakerData(data.data)
        })
    }
    console.log("New==", speakerData)
    useEffect(() => {
        handleSpeakerList()
        SpeakerListOptions()
    }, [])
    
    const SpeakerListOptions = () => {
        if (speakerData) {
            let SpeakerList = speakerData.map((ele) => {
                return {
                    value: ele["name"],
                  label: ele["name"] + (ele["company_name"] ? "(" + ele["company_name"] + ")" : "")
                };
            });
            console.log(SpeakerList)
            }
    }

    if (selectedSpeakerDataOption === "") {
        console.log(false)
    } else {
        console.log(selectedSpeakerDataOption)
    }
    
    return(
            <>
                {
                    activePage==="package_catalogue_list"?
                    (
                        <>
                            <PackageCatalogueTable
                                data={packageCatalogues}
                                isLoading={isLoading}
                                onCreatePackageClick={onCreatePackageClick}
                                onPackageServicesClicked={onPackageServicesClicked}
                                onEditPackagClicked={onEditPackagClicked}
                                onDeactivatePackagClicked={onDeactivatePackagClicked}
                                PackageTypesOptions={PackageTypesOptions}
                                selectedPackageTypeForFilter={selectedPackageTypeForFilter}
                                onPackageTypeChange={(option) => { setselectedPackageTypeForFilter(option);}}
                                PackageStatusOptions={PackageStatusOptions}
                                selectedPackageStatusForFilter={selectedPackageStatusForFilter}
                                onPackageStatusChange={(option) => { setselectedPackageStatusForFilter(option);}}
                                packageActiveStatusOptions={packageActiveStatusOptions}
                                selectedPackageActiveStatusOptionForFilter={selectedPackageActiveStatusOptionForFilter}
                                onPackageActiveStatusOptionChange={(option) => { setSelectedPackageActiveStatusOptionForFilter(option);}}
                                packageDeliveryOptions={packageDeliveryOptions}
                                selectedPackageDeliveryOptionForFilter={selectedPackageDeliveryOptionForFilter}
                                onPackageDeliveryChange={(option) => { setSelectedPackageDeliveryOptionForFilter(option);}}
                                onSearchClicked={handleSearchClick}
                                onClearFilterSearch={handleClearFilterSearch}
                                searchTerm={searchTerm}
                                onSearchInputChange={handleSearchInputChange}
                                setselectedStartDateFrom={setselectedStartDateFrom}
                                setselectedStartDateTo={setselectedStartDateTo}
                                selectedStartDateFrom={selectedStartDateFrom}
                                selectedStartDateTo={selectedStartDateTo}
                            />

                            <ConfirmationModalSmall
                                message="Are you sure you want to deactivate this Package/Offering?"
                                isOpen={showConfirmationModal}
                                toggleModal={toggleConfirmationModal}
                                onPositive={onSubmitDeactivatePackageCatalogue}
                            />
                        </>
                    ):
                    activePage==="create_package_catalogue"?
                    (
                        <CreatePackageCatalogue
                            PackageTypesOptions={PackageTypesOptions}
                            selectedPackageType={selectedPackageType}
                            PackageStatusOptions={PackageStatusOptions}
                            selectedPackageStatus={selectedPackageStatus}
                            packageDeliveryOptions={packageDeliveryOptions}
                            selectedPackageDeliveryOption={selectedPackageDeliveryOption}
                            onPackageDeliveryChange={(option) => { setSelectedPackageDeliveryOption(option);}}
                            onPackageStatusChange={(option) => { setselectedPackageStatus(option);}}
                            onPackageTypeChange={(option) => { setselectedPackageType(option);}}
                            isLoading={isLoading}
                            packageCatalogueData={packageCatalogueData}
                            onInputChange={handleCreatePackageCatalogueDataChange}
                            onCancelCreatePackageCatalogue={onCancelCreatePackageCatalogue}
                            onSubmitPackageCatalogue={onSubmitPackageCatalogue}
                            isEditPackageCatalogue={isEditPackageCatalogue}
                            onSubmitEditPackageCatalogue={onSubmitEditPackageCatalogue}
                            packageActiveStatusOptions={packageActiveStatusOptions}
                            selectedPackageActiveStatusOption={selectedPackageActiveStatusOption}
                            onPackageActiveStatusOptionChange={(option) => { setSelectedPackageActiveStatusOption(option);}}
                            sTypeOptions={sTypeOptions}
                            selectedsTypeOption={selectedsTypeOption}
                            onsTypeOptionChange={(option) => { setSelectedsTypeOption(option);}}
                        />
                    ):
                    activePage==="map_package_services"?
                    (
                        <>
                        <MapPackageServices
                            serviceCatalogueList={serviceCatalogueList}
                            selectedServiceCatalogue={selectedServiceCatalogue}
                            ServiceCatalogueOptions={serviceCatalogueListOptions}
                            selectedServiceCatalogueOption={selectedServiceCatalogueOption}
                            onServiceCatalogueChange={(option) => 
                            { 
                                if(option)
                                {
                                    /*const found = find(packageMappedServiceList, { refCatalogue: option.value });
                                    if (found) 
                                    {
                                        toast("Duplicate service can not be added.", {
                                            autoClose: 5000,
                                            type: toast.TYPE.ERROR,
                                        });
                                        return ;
                                    }
                                    else
                                    {
                                        setselectedServiceCatalogueOption(option);
                                    }*/
                                    setselectedServiceCatalogueOption(option);
                                }
                                else
                                {
                                    setselectedServiceCatalogueOption(option);
                                }
                            }}
                            externalServicePartnerOptions={externalServicePartnerList}
                            selectedExternalServicePartner={selectedExternalServicePartner}
                            onExternalServicePartnerChange={(option) => { setselectedExternalServicePartner(option);}}                            
                            isLoading={isLoading}
                            packageServiceMappingData={packageServiceMappingData}
                            onInputChange={handlePackageServiceMappingDataChange}
                            onAddPackageService={onAddPackageService}
                            onCancelPackageServiceMapping={onCancelPackageServiceMapping}
                            onSubmitPackageServiceMapping={onSubmitPackageServiceMapping}
                            packageMappedServiceList={packageMappedServiceList}
                            selectedPackageCatalogue={selectedPackageCatalogue}
                            viewIsForEditing={viewIsForEditing}
                            onEditMappedserviceClicked={onEditMappedserviceClicked}
                            onUpdatePackageService={onUpdatePackageService}
                            platformChargesOptions={platformChargesOptions}
                            selectedPlatformChargesOption={selectedPlatformChargesOption}
                            onPlatformChargesOptionChange={(option) => { setSelectedPlatformChargesOption(option);}}
                            GSTPercentageOptions={GSTPercentageOptions}
                            selectedGSTPercentageOption={selectedGSTPercentageOption}
                            onGSTPercentageOptionChange={(option) => { setSelectedGSTPercentageOption(option);}} 
                            onDeleteMappedserviceClicked={onDeleteMappedserviceClicked}
                            ResourceTypeOptions={ResourceTypeOptions}
                            selectedResourceTypeOption={selectedResourceTypeOption}
                            onResourceTypeOptionChange={(option) => { setSelectedResourceTypeOption(option);}} 
                            ResourceNameListOptions={ResourceNameListOptions}
                            selectedResourceNameListOption={selectedResourceNameListOption}
                                        onResourceNameListOptionChange={(option) => {
                                            setSelectedResourceNameListOption(option);
                                            console.log("Neww", selectedResourceNameListOption)
                                        }} 
                                        SpeakerListOptions={SpeakerListOptions}
                                        onSpeakerListOptionsChange={(option) => {
                                            setSelectedSpeakerDataOption(option)
                                        }}
                            OfferDeliveryTypeOptions={OfferDeliveryTypeOptions}
                            selectedOfferDeliveryTypeOption={selectedOfferDeliveryTypeOption}
                            onOfferDeliveryTypeOptionChange={(option) => { setSelectedOfferDeliveryTypeOption(option);}} 

                            
                        />

                        <ConfirmationModalSmall
                            message={selectedPackageCatalogue.sType===''||selectedPackageCatalogue.sType==="Package"?
                            "Are you sure you want to delete this service?":
                            "Are you sure you want to delete this resource?"}
                            isOpen={showConfirmationModal}
                            toggleModal={toggleConfirmationModal}
                            onPositive={onSubmitDeletePackageMappedservice}
                        />

                        <ConfirmationModalSmall
                            message={"You have unsaved changes,do you want to leave this page?"}
                            isOpen={showUnsavedConfirmationModal}
                            toggleModal={toggleUnsavedConfirmationModal}
                            onPositive={onConfirmCancelPackageServiceMapping}
                        />
                        </>
                    ):
                    activePage==="No_Access"?
                    (
                        <div className={`row row-container ${props.isLoading && "set-opacity"}`}>
                                <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                                <label>
                                    <b>You are not allowed to access this page, Please contact admin for more details.</b>
                                </label>         
                            </div>
                        </div>
                    )
                    :
                    (
                        ""
                    )         
                }
            </>
        );
}
